module.exports = __webpack_public_path__ + "media/vo-01-05.a06271ce.mp3";